import React, { useEffect, useState } from 'react'
import { v3_upload_plan_approval_document } from '../../../actions/v3/planApproval';
import { toast } from 'react-toastify';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { v4_fetch_mailbox_recipients, v4_mailbox_configuration } from '../../../actions/v4/mailBox';
import CreatableSelect from 'react-select/creatable';
import SendReport from './sendReport';
import { filterRecipientOption, mapRecipientOptions } from '../../MailBox/recipientSelectUtils';
import { buildReportAutoSubject, getLoggedInUserRoleId, REPORT_SUBJECT_PREFIXES } from '../../../utils';
import { uploadSelectedFiles } from '../../../utils/multipleFileUpload';

const ACCEPTED_REPORT_RECEIVED_STATUS = 'Accepted, Report received';
const ACCEPTED_REPORT_RECIEVED_STATUS = 'Accepted, Report recieved';
const LEGACY_ACCEPTED_STATUS = 'Accepted';

const normalizeAcceptedStatus = (status) =>
    status === ACCEPTED_REPORT_RECEIVED_STATUS || status === ACCEPTED_REPORT_RECIEVED_STATUS || status === LEGACY_ACCEPTED_STATUS ? LEGACY_ACCEPTED_STATUS : status;

const toApiCommentStatus = (status) =>
    status === ACCEPTED_REPORT_RECEIVED_STATUS || status === ACCEPTED_REPORT_RECIEVED_STATUS ? LEGACY_ACCEPTED_STATUS : status;

const decodeMojibake = (value) => {
    if (!value || typeof value !== 'string' || value.includes('�')) return value;

    const decodeOnce = (input) => {
        if (!/[\u00C0-\u00FF]/.test(input)) return input;
        if (typeof TextDecoder === 'undefined' || typeof TextEncoder === 'undefined') return input;

        try {
            const sourceBytes = Uint8Array.from(input, (ch) => ch.charCodeAt(0) & 0xff);
            const decoded = new TextDecoder('utf-8', { fatal: false }).decode(sourceBytes);
            if (!decoded || decoded.includes('\u0000')) return input;

            const reEncoded = new TextEncoder().encode(decoded);
            if (reEncoded.length !== sourceBytes.length) return input;

            for (let i = 0; i < reEncoded.length; i += 1) {
                if (reEncoded[i] !== sourceBytes[i]) return input;
            }

            return decoded;
        } catch (error) {
            return input;
        }
    };

    let current = value;
    for (let i = 0; i < 2; i += 1) {
        const next = decodeOnce(current);
        if (next === current) break;
        current = next;
    }

    return current;
};

const getUploadedFiles = (files = []) => (
    Array.isArray(files)
        ? files.filter((file) => file?.fileName && file?.originalFileName)
        : []
);

const Comments = ({ data, fatId, fatMeta, onAddComment, onChangeFavouriteStatus, onDeleteComment, selectComment, onUpdateStatus }) => {
    const [mailBoxes, setMailBox] = useState([]);
    const isAdmin = Number(getLoggedInUserRoleId()) === 1;
    const sendMailModalId = `sendMail-fat-${fatId || 'default'}`;
    const reportReference = fatMeta?.REFERENCE_NUMBER ?? fatMeta?.referenceNumber ?? fatMeta?.FAT_NUMBER ?? fatMeta?.fatNumber;
    const autoSubject = buildReportAutoSubject(
        fatMeta?.SUBJECT ?? fatMeta?.subject,
        reportReference,
        REPORT_SUBJECT_PREFIXES.fat
    );

    const [state, setState] = useState({
        comment: { name: 'comment', value: '', error: '', isRequired: true },
        document: { name: 'document', value: [{ fileName: '', originalFileName: '' }], isRequired: false, error: '' },

    })

    const handleFileChange = async (index, files) => {
        const uploadedFiles = await uploadSelectedFiles(files, v3_upload_plan_approval_document);
        if (!uploadedFiles.length) return;

        setState(prev => {
            const updatedFiles = [...prev.document.value];
            updatedFiles.splice(index, 1, ...uploadedFiles);
            return {
                ...prev,
                document: { ...prev.document, value: updatedFiles, error: '' }
            };
        });
    };

    const addFileField = () => {
        setState(prev => ({
            ...prev,
            document: {
                ...prev.document,
                value: [...prev.document.value, { fileName: '', originalFileName: '' }],
                error: ''
            }
        }));
    };

    const removeFileField = (index) => {
        const updatedFiles = state.document.value.filter((_, i) => i !== index);
        setState(prev => ({
            ...prev,
            document: {
                ...prev.document,
                value: updatedFiles,
                error: updatedFiles.length === 0 ? 'At least one document is required' : ''
            }
        }));
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prev => ({
            ...prev,
            [name]: { ...prev[name], value, error: '' }
        }));
    };

    const handleSubmit = () => {

        // 1. Validate required fields
        let isValid = true;
        const updatedState = { ...state };

        Object.keys(state).forEach((key) => {
            if (state[key].isRequired && !state[key].value) {
                updatedState[key].error = 'This field is required';
                isValid = false;
            }
        });

        setState(updatedState);
        if (!isValid) {
            toast.error('Please fill all required fields.');
            return;
        }

        // 2. Build payload
        const payload = {
            comment: state.comment.value,
            document: getUploadedFiles(state.document.value),
            revisionId: data?.ID
        };

        onAddComment(payload)
    };


    const [statusState, setStatusState] = useState({
        status: {
            name: 'status', value: '', error: '', options: ['Draft', 'Open', 'Archived', LEGACY_ACCEPTED_STATUS, 'Cancelled', 'To Be Confirmed'], isRequired: true
        },
        remarks: { name: 'remarks', value: '', error: '', isRequired: false },

        comment: { name: 'comment', value: '', error: '', isRequired: true },
        document: { name: 'document', value: [{ fileName: '', originalFileName: '', existing: false }], isRequired: false, error: '' },

        sentEmail: { name: 'sentEmail', value: false, isRequired: false, error: '' },

        fromEmailId: { name: 'fromEmailId', value: '', error: '', isRequired: false },
        email: { name: 'email', value: [], options: [], error: '', isRequired: false },
        subject: { name: 'subject', value: '', error: '', isRequired: false },
        body: { name: 'body', value: '', error: '', isRequired: false },
        cc: { name: 'cc', value: [], options: [], error: '', isRequired: false },
    })
    useEffect(() => {
        v4_fetch_mailbox_recipients().then((res) => {
            if (res.status) {
                const options = mapRecipientOptions(res.result);
                setStatusState((prev) => ({
                    ...prev,
                    ['email']: {
                        ...prev['email'], options
                    },
                    ['cc']: {
                        ...prev['cc'], options
                    },
                }));
            }
        })
    }, [])


    const handleMultiSelectChange = (selectedOptions, name) => {
        setStatusState((prev) => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: selectedOptions,
                error: '',
            },
        }));
    };
    useEffect(() => {
        if (statusState.sentEmail.value && mailBoxes.length === 0) {
            v4_mailbox_configuration().then((res) => {
                if (res.status) {
                    setMailBox(res.result);

                }
            });
        }
    }, [statusState.sentEmail.value]);

    useEffect(() => {
        if (!statusState.sentEmail.value || !autoSubject) return;

        setStatusState((prev) => {
            if (prev.subject.value) return prev;
            return {
                ...prev,
                subject: {
                    ...prev.subject,
                    value: autoSubject,
                },
            };
        });
    }, [statusState.sentEmail.value, autoSubject]);

    const handleStatusStateChange = (e) => {
        const { name, value } = e.target;
        setStatusState(prev => ({
            ...prev,
            [name]: { ...prev[name], value, error: '' }
        }));
    };
    const handleStatusFileChange = async (index, files) => {
        const uploadedFiles = await uploadSelectedFiles(files, v3_upload_plan_approval_document);
        if (!uploadedFiles.length) return;

        setStatusState(prev => {
            const updatedFiles = [...prev.document.value];
            updatedFiles.splice(index, 1, ...uploadedFiles.map((file) => ({ ...file, existing: false })));
            return {
                ...prev,
                document: { ...prev.document, value: updatedFiles, error: '' }
            };
        });
    };
    const handleStatusUpdateSubmit = (commentId) => {

        // 1. Validate required fields
        let isValid = true;
        const updatedState = { ...statusState };

        Object.keys(statusState).forEach((key) => {
            if (statusState[key].isRequired && !statusState[key].value) {
                updatedState[key].error = 'This field is required';
                isValid = false;
            }
        });

        setStatusState(updatedState);
        if (!isValid) {
            toast.error('Please fill all required fields.');
            return;
        }

        const toEmails = statusState.email.value.map((e) => e.value);
        const ccEmails = statusState.cc.value.map((e) => e.value);
        const subject = buildReportAutoSubject(statusState.subject.value, reportReference, REPORT_SUBJECT_PREFIXES.fat);

        // 2. Build payload
        const payload = {
            remarks: statusState.remarks.value,
            status: toApiCommentStatus(statusState.status.value),
            fatId: data.FAT_ID,
            revisionId: data.ID,
            commentId,
            comment: statusState.comment.value,
            document: getUploadedFiles(statusState.document.value),
            sentEmail: statusState.sentEmail.value,
            to: toEmails,
            subject,
            html: statusState.body.value,
            id: statusState.fromEmailId.value,
            cc: ccEmails
        };

        onUpdateStatus(payload)
    };

    return (

        <>
            <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title mb-0">Comments</h4>
                <div>
                    <button
                        type="button"
                        className="btn btn-sm btn-primary me-2"
                        style={{
                            backgroundImage:
                                "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))"
                        }}
                        data-bs-toggle="modal"
                        data-bs-target={`#${sendMailModalId}`}
                    >
                        <i className="fas fa-paper-plane label-icon" /> Send Report

                    </button>
                    <button
                        type="button"
                        className="btn btn-sm btn-primary me-2"
                        data-bs-toggle="modal"
                        data-bs-target={`#commentModal`}
                        style={{
                            backgroundImage:
                                "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))"
                        }}
                    >
                        <i className="fa fa-plus-circle label-icon" /> Create Comment
                    </button>

                </div>
            </div>

            <div
                className="modal fade"
                id={sendMailModalId}
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex={-1}
                role="dialog"
                aria-labelledby={`${sendMailModalId}Label`}
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id={`${sendMailModalId}Label`}>
                                Send Report Mail
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <SendReport
                                key={fatId || 'fat-send-report'}
                                data={{
                                    fatId,
                                    subject: fatMeta?.SUBJECT,
                                    referenceNumber: fatMeta?.REFERENCE_NUMBER,
                                    fatNumber: fatMeta?.FAT_NUMBER,
                                }}
                                modalId={sendMailModalId}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="modal fade"
                id={`commentModal`}
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex={-1}
                role="dialog"
                aria-labelledby="commentModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="commentModalLabel">
                                Add Comment
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <label>Comment {state['comment'].isRequired && <span className='text-danger'> *</span>}</label>
                                    <textarea
                                        row='2'
                                        name={'comment'}
                                        placeholder='Enter Comment'
                                        value={state['comment'].value}
                                        onChange={handleChange}
                                        className={`form-control ${state['comment'].error ? 'is-invalid' : ''}`}
                                    />
                                    {state['comment'].error && <div className="invalid-feedback">{state['comment'].error}</div>}
                                </div>
                                <div className="col-md-12 mb-3">
                                    <label>Supporting File <span >*</span></label>
                                    {state.document.value.map((item, index) => (
                                        <div key={index} className="d-flex align-items-center mb-2">
                                            {item.fileName ? (
                                                <>
                                                    <div className="me-2 flex-grow-1">
                                                        <span>{decodeMojibake(item.originalFileName || item.fileName)}</span>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={() => removeFileField(index)}
                                                    >
                                                        <FaTrash />
                                                    </button>
                                                </>
                                            ) : (
                                                <>
                                                    <input
                                                        type="file"
                                                        multiple
                                                        onChange={(e) => handleFileChange(index, e.target.files)}
                                                        className="form-control me-2"
                                                    />
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={() => removeFileField(index)}
                                                    >
                                                        <FaTrash />
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    ))}
                                    <div>
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary"
                                            onClick={addFileField}
                                        >
                                            <FaPlus className="me-1" /> Add Document
                                        </button>
                                    </div>
                                    {state['document'].error && <div className="invalid-feedback">{state['document'].error}</div>}
                                </div>
                            </div>
                            <div className="mt-3">
                                <button type="submit" className="btn btn-success me-2"
                                    onClick={() => {
                                        handleSubmit()

                                    }}
                                >Submit</button>
                                <button className="btn btn-danger text-white" onClick={() => {
                                    const modal = window.bootstrap.Modal.getInstance(document.getElementById(`commentModal`));
                                    if (modal) modal.hide();
                                }}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {data?.comments?.map((item) => {
                const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']

                const initials = item.CREATED_BY_NAME
                    .split(' ')
                    .map(word => word.charAt(0).toUpperCase())
                    .join('');
                return (
                    <div className="plan-item-section" key={item.ID}>


                        <div className="plan-item-details mt-2">
                            <div className="user-name"
                                onClick={() => {
                                    selectComment(item.ID)
                                }}
                            >{initials}


                            </div>
                            <div className="plan-modal">
                                <p onClick={() => {
                                    selectComment(item.ID)
                                }}>
                                    {item.COMMENT}
                                </p >
                                <div className="paln-signatur">
                                    <div className="plan-about-user" onClick={() => {
                                        selectComment(item.ID)
                                    }}>
                                        <p>
                                            Create By <span>{item.CREATED_BY_NAME}</span>
                                        </p>
                                        <p>
                                            Opened Against rev <span>{item.REVISION_NAME}</span>
                                        </p>
                                        <p className="cat-para">{normalizeAcceptedStatus(item.STATUS)}</p>

                                    </div>
                                    <div className="plan-about-user-copy">
                                        <p>

                                            <a
                                                href='#'
                                                data-bs-toggle="modal"
                                                data-bs-target={`#statusUpdateModal-${item.ID}`}
                                                onClick={() => {
                                                    const documents = Array.isArray(item.commentDocuments) ? item.commentDocuments : [];
                                                    setStatusState(prev => ({
                                                        ...prev,
                                                        status: {
                                                            ...prev.status,
                                                            value: normalizeAcceptedStatus(item.STATUS)
                                                        },
                                                        comment: {
                                                            ...prev.comment,
                                                            value: item.COMMENT
                                                        },
                                                        document: {
                                                            ...prev.document,
                                                            value: documents.length > 0 ? documents.map((doc) => {
                                                                return {
                                                                    fileName: doc.FILE_NAME,
                                                                    originalFileName: decodeMojibake(doc.ORIGINAL_FILE_NAME || doc.FILE_NAME),
                                                                    existing: true
                                                                }
                                                            }) : [{ fileName: '', originalFileName: '', existing: false }]
                                                        }
                                                    }));
                                                }}
                                            >
                                                <i

                                                    className="bx bx-edit"
                                                    aria-hidden="true"
                                                />
                                            </a>

                                            <div
                                                className="modal fade"
                                                id={`statusUpdateModal-${item.ID}`}
                                                data-bs-backdrop="static"
                                                data-bs-keyboard="false"
                                                tabIndex={-1}
                                                role="dialog"
                                                aria-labelledby="statusUpdateModalLabel"
                                                aria-hidden="true"
                                            >
                                                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                                    <div className="modal-content">
                                                        <div className="modal-header">
                                                            <h5 className="modal-title" id="statusUpdateModalLabel">
                                                                Edit Comment
                                                            </h5>
                                                            <button
                                                                type="button"
                                                                className="btn-close"
                                                                data-bs-dismiss="modal"
                                                                aria-label="Close"
                                                            />
                                                        </div>
                                                        <div className="modal-body">
                                                            <div className="row">
                                                                <div className="col-md-12 mb-3">
                                                                    <label>Status {statusState.status.isRequired && <span className='text-danger'> *</span>}</label>
                                                                    <select
                                                                        name={'status'}
                                                                        value={statusState['status'].value}
                                                                        onChange={handleStatusStateChange}
                                                                        className={`form-control ${statusState['status'].error ? 'is-invalid' : ''}`}
                                                                    >
                                                                        <option value=''>Select Status</option>
                                                                        {statusState.status.options.map((status) => {
                                                                            return (
                                                                                <option value={status}>{status}</option>

                                                                            )
                                                                        })}
                                                                    </select>
                                                                    {statusState['status'].error && <div className="invalid-feedback">{statusState['status'].error}</div>}
                                                                </div>

                                                                <div className="col-md-12 mb-3">
                                                                    <label>Comment <span >*</span></label>
                                                                    <textarea
                                                                        row='2'
                                                                        name={'comment'}
                                                                        placeholder='Enter Comment'
                                                                        value={statusState['comment'].value}
                                                                        onChange={(e) => {
                                                                            const { name, value } = e.target;
                                                                            setStatusState(prev => ({
                                                                                ...prev,
                                                                                [name]: { ...prev[name], value, error: '' }
                                                                            }));
                                                                        }}
                                                                        className={`form-control ${statusState['comment'].error ? 'is-invalid' : ''}`}
                                                                    />
                                                                    {statusState['comment'].error && <div className="invalid-feedback">{statusState['comment'].error}</div>}
                                                                </div>
                                                                <div className="col-md-12 mb-3">
                                                                    <label>Supporting File</label>
                                                                    {statusState.document.value.map((item, index) => (
                                                                        <div key={index} className="d-flex align-items-center mb-2">
                                                                            {item.fileName ? (
                                                                                <>
                                                                                    <div className="me-2 flex-grow-1">
                                                                                        <span>{decodeMojibake(item.originalFileName || item.fileName)}</span>
                                                                                    </div>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-outline-danger"
                                                                                        onClick={() => {

                                                                                            const updatedFiles = statusState.document.value.filter((_, i) => i !== index);
                                                                                            setStatusState(prev => ({
                                                                                                ...prev,
                                                                                                document: {
                                                                                                    ...prev.document,
                                                                                                    value: updatedFiles,
                                                                                                    error: ''
                                                                                                }
                                                                                            }));
                                                                                        }}
                                                                                    >
                                                                                        <FaTrash />
                                                                                    </button>
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <input
                                                                                        type="file"
                                                                                        multiple
                                                                                        onChange={(e) => handleStatusFileChange(index, e.target.files)}
                                                                                        className="form-control me-2"
                                                                                    />
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-outline-danger"
                                                                                        onClick={() => {

                                                                                            const updatedFiles = statusState.document.value.filter((_, i) => i !== index);
                                                                                            setStatusState(prev => ({
                                                                                                ...prev,
                                                                                                document: {
                                                                                                    ...prev.document,
                                                                                                    value: updatedFiles,
                                                                                                    error: ''
                                                                                                }
                                                                                            }));
                                                                                        }}
                                                                                    >
                                                                                        <FaTrash />
                                                                                    </button>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    ))}
                                                                    <div>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-outline-primary"
                                                                            onClick={() => {
                                                                                setStatusState(prev => ({
                                                                                    ...prev,
                                                                                    document: {
                                                                                        ...prev.document,
                                                                                        value: [...prev.document.value, { fileName: '', originalFileName: '', existing: false }],
                                                                                        error: ''
                                                                                    }
                                                                                }));
                                                                            }}
                                                                        >
                                                                            <FaPlus className="me-1" /> Add Document
                                                                        </button>
                                                                    </div>
                                                                    {statusState['document'].error && <div className="invalid-feedback">{statusState['document'].error}</div>}
                                                                </div>


                                                                <div className="col-md-12 mb-3">
                                                                    <label>Send Email ? </label>
                                                                    &nbsp;
                                                                    &nbsp;
                                                                    <input
                                                                        type="checkbox"
                                                                        name={'sentEmail'}
                                                                        checked={statusState.sentEmail.value === true}
                                                                        onChange={(e) => {
                                                                            const checked = e.target.checked;

                                                                            setStatusState(prev => ({
                                                                                ...prev,
                                                                                sentEmail: {
                                                                                    ...prev.sentEmail,
                                                                                    value: checked,
                                                                                },
                                                                                fromEmailId: {
                                                                                    ...prev.fromEmailId,
                                                                                    isRequired: checked,
                                                                                },
                                                                                email: {
                                                                                    ...prev.email,
                                                                                    isRequired: checked,
                                                                                },
                                                                                subject: {
                                                                                    ...prev.subject,
                                                                                    isRequired: checked,
                                                                                },
                                                                                body: {
                                                                                    ...prev.body,
                                                                                    isRequired: checked,
                                                                                },
                                                                            }));
                                                                        }}
                                                                        className={`mt-1 form-check-input ${statusState['sentEmail'].error ? 'is-invalid' : ''}`}
                                                                    />
                                                                </div>
                                                                {statusState.sentEmail.value &&
                                                                    <div>
                                                                        <div className="mb-3">
                                                                            <select
                                                                                isMulti
                                                                                name="fromEmailId"
                                                                                value={statusState.fromEmailId.value}
                                                                                onChange={handleStatusStateChange}
                                                                                className="form-select"
                                                                            >
                                                                                <option value={''}> Send From </option>
                                                                                {mailBoxes?.map((mail) => {
                                                                                    return (
                                                                                        <option value={mail.ID}>{mail.EMAIL} </option>
                                                                                    )
                                                                                })}
                                                                            </select>
                                                                            {statusState.fromEmailId.error && <small className="text-danger">{statusState.fromEmailId.error}</small>}
                                                                        </div>
                                                                        <div className="mb-3">
                                                                            <CreatableSelect
                                                                                isMulti
                                                                                name="email"
                                                                                value={statusState.email.value}
                                                                                options={statusState.email.options} // Optional: preload some emails if needed
                                                                                filterOption={filterRecipientOption}
                                                                                onChange={(e) => handleMultiSelectChange(e, 'email')}
                                                                                className="basic-multi-select"
                                                                                classNamePrefix="select"
                                                                                placeholder="To"
                                                                                isClearable
                                                                            />
                                                                            {statusState.email.error && <small className="text-danger">{statusState.email.error}</small>}
                                                                        </div>
                                                                        {statusState.email.value.length > 0 && <div className="mb-3">
                                                                            <CreatableSelect
                                                                                isMulti
                                                                                name="cc"
                                                                                value={statusState.cc.value}
                                                                                options={statusState.cc.options} // Optional: preload some emails if needed
                                                                                filterOption={filterRecipientOption}
                                                                                onChange={(e) => handleMultiSelectChange(e, 'cc')}
                                                                                className="basic-multi-select"
                                                                                classNamePrefix="select"
                                                                                placeholder="CC"
                                                                                isClearable
                                                                            />
                                                                            {statusState.cc.error && <small className="text-danger">{statusState.cc.error}</small>}
                                                                        </div>}
                                                                        <div className="mb-3">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="subject"
                                                                                value={statusState.subject.value}
                                                                                onChange={handleStatusStateChange}
                                                                                placeholder="Subject"
                                                                            />
                                                                            {statusState.subject.error && <small className="text-danger">{statusState.subject.error}</small>}
                                                                        </div>
                                                                        <div className="mb-3">
                                                                            <textarea
                                                                                className="form-control"
                                                                                rows="5"
                                                                                name="body"
                                                                                value={statusState.body.value}
                                                                                onChange={handleStatusStateChange}
                                                                                placeholder="Write your message..."
                                                                            />
                                                                            {statusState.body.error && <small className="text-danger">{statusState.body.error}</small>}
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className="mt-3">
                                                                <button className="btn btn-success me-2"
                                                                    onClick={() => {
                                                                        handleStatusUpdateSubmit(item.ID)
                                                                    }}
                                                                >Submit</button>

                                                                <button className="btn btn-danger text-white" onClick={() => {
                                                                    const modal = window.bootstrap.Modal.getInstance(document.getElementById(`statusUpdateModal-${item.ID}`));
                                                                    if (modal) modal.hide();
                                                                }}>Cancel</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <br />
                                            <a href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    navigator.clipboard.writeText(item.COMMENT);
                                                    toast.success('Copied to clipboard!');
                                                }}>
                                                {" "}
                                                <i
                                                    className="mdi mdi-content-copy"
                                                    aria-hidden="true"
                                                />
                                            </a>

                                            {isAdmin && (
                                                <>
                                                    <br />
                                                    <button
                                                        type="button"
                                                        className="btn btn-link p-0 text-danger"
                                                        title="Delete comment"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();

                                                            if (window.confirm('Delete this FAT comment?')) {
                                                                onDeleteComment({ commentId: item.ID });
                                                            }
                                                        }}
                                                    >
                                                        <FaTrash aria-hidden="true" />
                                                    </button>
                                                </>
                                            )}

                                            <br />
                                            <i
                                                className={`bx ${Number(item.IS_FAVOURITE) ? 'bxs-star' : 'bx-star'}`}
                                                style={{ color: Number(item.IS_FAVOURITE) ? '#f1c40f' : '#999', cursor: 'pointer' }}
                                                onClick={() => {
                                                    onChangeFavouriteStatus({
                                                        commentId: item.ID,
                                                        comment: item.COMMENT,
                                                        favouriteStatus: Number(!Number(item.IS_FAVOURITE)),
                                                    });
                                                }}
                                            />
                                        </p>
                                    </div>
                                </div>
                                <div className="uplodeimageseep row">
                                    {item.commentDocuments.map((doc, i) => {
                                        const displayFileName = decodeMojibake(doc.ORIGINAL_FILE_NAME || doc.FILE_NAME);
                                        const fileExt = displayFileName?.split(".").pop()?.toLowerCase();
                                        const isImage = imageExtensions.includes(fileExt);
                                        const previewUrl = `${process.env.REACT_APP_BASE_URL}/v3/fat/document/preview/${doc.FAT_ID}/${doc.REV_ID}/${doc.FILE_NAME}`;
                                        const downloadUrl = `${process.env.REACT_APP_BASE_URL}/v3/fat/document/download/${doc.FAT_ID}/${doc.REV_ID}/${doc.FILE_NAME}`;
                                        return (
                                            <div key={i} className="col-md-3 col-sm-3 col-12 mb-3">
                                                <div className="uplodeitem border rounded p-2 h-100 text-center shadow-sm" style={{ width: 'auto' }}>
                                                    {isImage ? (
                                                        <div className="ship-img-box mb-2">
                                                            <img
                                                                src={previewUrl}
                                                                alt={displayFileName}
                                                                className="img-fluid rounded"
                                                                style={{
                                                                    maxHeight: "160px",
                                                                    objectFit: "cover",
                                                                    width: "100%",
                                                                }}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className="d-flex justify-content-center align-items-center mb-2" style={{ height: "160px" }}>
                                                            <i className="ri-file-line fs-40 text-muted"></i>
                                                        </div>
                                                    )}

                                                    <div className="img-caption">
                                                        <p className="text-truncate mb-0">
                                                            <a
                                                                href={previewUrl}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="text-decoration-none fw-semibold"
                                                            >
                                                                {displayFileName}
                                                            </a>
                                                        </p>
                                                        <div className="d-flex justify-content-center gap-2 mt-1">
                                                            <a href={previewUrl} target="_blank" rel="noopener noreferrer" className="small text-info">Preview</a>
                                                            <a href={downloadUrl} target="_blank" rel="noopener noreferrer" className="small">Download</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}


        </>


    )
}

export default Comments
